import { BObjectModel, BoModel } from '../bodisplay';
import { QueovalBase, QueovalItem, Formateur, Stage, Apprenant, QueovalDik, QueovalDate, QueovalDateTime } from '../global';
import { BlockTree } from '../blocked';

//#region agenda v2
export class AgendaModelV3 extends QueovalBase {
  public isPlanning: boolean;
  public ConnGoogle: boolean;
  public BeginWorkAgenda: number;
  public EndWorkAgenda: number;
  public selectedEvent: SelectedEvent;
  public selectedDate: QueovalDate;
  public agendaMode: string;
  public dayByWeek: number;
  public totalDays: number;
  public CheckedSelectEvents: Array<SelectAgendaEvent>;
  public listCalendars: Array<Calendar>;
  public getInfos: boolean;
  public selectedOwnerIndex: number;
  public GroupMode: string;
  constructor() {
    super()
    this.listCalendars = [];
  }
}
export class Calendar {
  public calendarOwnerId: string;
  public height: number;
  public maxEvents: number;
  public selectEvents: Array<SelectAgendaEvent>;
  public header: AgendaHeader;
  public body: AgendaBody;
  public calendarOBjectId: string;
  public calendarOfficeId: string;
  public calendarGroupId : string;
  constructor(calendarOwnerId: string = '', calendarOBjectId: string = '', calendarOfficeId: string = '', calendarGroupId : string = '') {
    this.selectEvents = [];
    this.calendarOwnerId = calendarOwnerId;
    this.header = new AgendaHeader();
    this.body = new AgendaBody();
    this.calendarOBjectId = calendarOBjectId;
    this.calendarOfficeId = calendarOfficeId;
    this.calendarGroupId = calendarGroupId ;
  }
}

export class SelectedEvent {
  public pEvent: AgendaEvent;
  public boModel: BoModel;
}

export class AgendaHeader {
  public userName: string;
  public userImage: string;
 
}
export class AgendaBody {
  public startDate: QueovalDate;
  public endDate: QueovalDate;
  public WeekNumbers: Array<number>;
  public dailyRows: Array<AgendaRow>;
  public weeklyRows: Array<AgendaRow>;
}
export class AgendaEvent {
  public ident: string;
  public pere: string;
  public relation: string;
  public code_DOR: string;
  public GroupMode: string;
  public position: number;
  public label: string;
  public startDate: QueovalDateTime;
  public endDate: QueovalDateTime;
  public type: string;
  public clipPath: string;
  public left: string;
  public padding: number;
  public colspan: number;
  public width: string;
  public height: string;
  public top: string;
  public color: string;
  public borderColor: string;
  public infos: Array<QueovalDik>;
  public isReadable: boolean;
  public isUpdatable: boolean;
  public isDeletable: boolean;
  public isAnonimized: boolean;
  public isMultiDay: boolean;
  public isMain: boolean;
}
export class AgendaRow {
  public id: number;
  public height: number;
  public cols: Array<AgendaCol>;
  public maxEvents: number;
}
export class AgendaCol {
  public id: number;
  public events: Array<AgendaEvent>;
  public IsWorkingDay: boolean;
}
export class SelectAgendaEvent {
  public label: string;
  public color: string;
  public code: string;
  public type: string;
  public idRelation: string;
  public isChecked: boolean;
  public isReadable: boolean;
  public isUpdatable: boolean;
  public isCreatable: boolean;
  public GroupMode: string;
  public detail: Array<DetailSelectAgendaEvent>;
}

export class DetailSelectAgendaEvent {
  public name: string;
  public value: string;
  public list: Array<ListDetailSelectAgendaEvent>;
}
export class ListDetailSelectAgendaEvent {
  public key: string;
  public value: string;
  public isChecked: boolean;
  public type: string;
}

//#endregion

//#region v1
export class AgendaModel extends QueovalBase {
  public ConnectedUserImage: string;
  public ListDay: DayDisplay[];
  public ListWeek: WeekDisplay[];
  public ListAgenda: SelectAgenda[];
  public ListHour: string[];
  public Week: string;
  public Mode: string;
  public DREF: string;
  public GMT: string;
  public Title: string;
  public BeginWorkAgenda: number | null;

  constructor() {
    super();
    this.ListDay = [];
    this.ListHour = [];
    this.ListWeek = [];
    this.ListAgenda = [];
  }
}

export class WeekDisplay {
  public WeekNumber: string;
  public ListDay: DayDisplay[];
  constructor() {
    this.ListDay = [];
  }
}

export class DayDisplay {
  public DayText: string;
  public DayNum: string;
  public Today: string;
  public Date: Date;
  public ListRdv: RdvDisplay[];
  public ListRdvonDay: RdvDisplay[];
  public tblZindex: Int32Array[];
  constructor() {
    this.ListRdv = [];
    this.ListRdvonDay = [];
  }
}

export class SelectAgenda {
  public Text: string;
  public classBackground: string;
  public Code: string;
  public Check: boolean;
  public Ecriture: boolean;
  public Modale: string;
  public BOModel: BObjectModel;
  public ModeAffiche: string;
}


export class RdvDisplay {
  public classDisplay: string;
  public classBackground: string;
  public classDisponibilite: string;
  public objet: string;
  public left: string;
  public classBorder: string;
  public top: string;
  public width: string;
  public BegginHour: string;
  public bHour: number;
  public eHour: number;
  public height: string;
  public zindex: string;
  public url: string;
  public targuet: string;
  public Ident: string;
  public IsModifiable: boolean;
  public BOModel: BObjectModel;
  public modeAffiche: string;
  public Info: string;
  public objInfo: QueovalDik;
  public clipPath: string;
}

export class RdvAgenda {
  public BeginHour: number;
  public EndHour: number;
  public Ident: string;
  public width: string;
  public border: string;
  public left: string;

  constructor() {
    this.border = '1px black solid';
  }
}

export class DateModel {
  public year: number;
  public month: number;
  public day: number;
  constructor() {
    const d: Date = new Date();
    this.day = d.getDate();
    this.month = d.getMonth() + 1;
    this.year = d.getFullYear();
  }
}

export class EventsModel extends QueovalBase {
  public EventId: string;
  public ListEventId: string[];
  public EventData: any;
  public EventMode: DataMode;
  public RelationData: QueovalItem;
  public DataReservation: ReservationData;
  public DataRendezvous: RendezVousData;
  public DataResaStagiaire: ReservationStagiaireData;
  public ListFormateur: Formateur[];
  public Lieu: BObjectModel;
  public ListStage: Stage[];
  public ListApprenant: Apprenant[];
  public ListAffaire: Affaire[];
  public UpdateDate: UpdateDate;
  public IdStage: string;
  public Code: string;
  public Ident: string;
  public idUserEvent: string;
  constructor() {
    super();
    this.idUserEvent = '';
    this.ListFormateur = [];
    this.ListStage = [];
    this.ListApprenant = [];
  }
}

export class UpdateDate {
  public idPere: string;
  public idFils: string;
  public idRelation: string;
  public dateDebut: QueovalDate;
  public heureDebut: number;
  public minDebut: number;
}

export class GroupObjetReservation {
  public titre: string;
  public objet: string;
}

export class StageInfoReservation {
  public title: string;
  public debut: string;
  public fin: string;
}

export class AdresseInfoReservation {
  public denomination: string;
  public adresse1: string;
  public adresse2: string;
  public adresse3: string;
  public codePostal: string;
  public ville: string;
  public latitude: number;
  public longitude: number;
  public groupAndReservation: Array<GroupObjetReservation>;
}



export class Affaire {
  public BOModel: BObjectModel;
  public strIdent: String;
  public nomAffaire: string;
}

export class ReservationData {
  public EditStageReservations: boolean;
  public LinkStageDetails: string;
  public SelectedStages: Array<QueovalItem>;
  public SelectedBureau: QueovalItem;
  public SelectedLieu: QueovalItem;

  public ListStagiaires: Array<Apprenant>;
  public ListStageReservations: Array<string>;
  public ListBureaux: Array<QueovalItem>;
  public ListStagesByClients: Array<QueovalItem>;
  public ListLieux: Array<QueovalItem>;
  public ListParticipants: BlockTree;
  public ListObjects: BlockTree;
}

export class RendezVousData {
  public IsModeAffaire: boolean;
  public RdvSelectedClient: QueovalItem;
  public RdvSelectedContact: Array<QueovalItem>;
  public ListStagesByClients: Array<QueovalItem>;
  public RdvSelectedAffaire: QueovalItem;
  public ListParticipants: BlockTree;

  public ListContacts: Array<QueovalItem>;
  public ListAffaires: Array<QueovalItem>;
  public IsSendInvitation: boolean;
}

export class ReservationStagiaireData {
  public ListFormateurs: Array<Formateur>;
  public StageData: BObjectModel;
  public StageAddress: BObjectModel;
  public infoStage: StageInfoReservation;
  public infoAdresse: AdresseInfoReservation;
  public infoReservation: StageInfoReservation;
}

export enum DataMode {
  CREATE = 1,
  EDIT = 2,
  DELETE = 3
}
//#endregion
